(() => {
  const storageKey = 'payke:blog-scroll-restore';

  const getPageKey = () => `${window.location.pathname}${window.location.search}`;

  const getStoredState = () => {
    try {
      return JSON.parse(window.sessionStorage.getItem(storageKey));
    } catch (error) {
      return null;
    }
  };

  const setStoredState = (state) => {
    try {
      window.sessionStorage.setItem(storageKey, JSON.stringify(state));
    } catch (error) {}
  };

  const isBackForwardNavigation = (event) => {
    const navigationEntry = window.performance.getEntriesByType('navigation')[0];

    return event.persisted || navigationEntry?.type === 'back_forward';
  };

  const isModifiedClick = (event) => event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0;

  const isArticleLink = (link) => {
    const url = new URL(link.href, window.location.href);

    if (url.origin !== window.location.origin) {
      return false;
    }

    if (url.pathname.includes('/tagged/')) {
      return false;
    }

    return Boolean(link.closest('.article-card, .c-news-blog__item'));
  };

  const revealPage = () => {
    document.documentElement.classList.remove('blog-scroll-restore-pending');
  };

  const restoreScrollPosition = (event) => {
    if (!isBackForwardNavigation(event)) {
      revealPage();
      return;
    }

    const root = document.querySelector('[data-blog-scroll-restore]');
    const state = getStoredState();

    if (!root || !state || state.page !== getPageKey() || typeof state.scrollY !== 'number') {
      revealPage();
      return;
    }

    const targetY =
      typeof window.__blogScrollRestoreTarget === 'number'
        ? window.__blogScrollRestoreTarget
        : Math.max(0, state.scrollY);
    let attempts = 0;

    const scrollToTarget = () => {
      window.scrollTo({ top: targetY, behavior: 'auto' });
      attempts += 1;

      if (attempts === 2) {
        revealPage();
      }

      if (attempts < 8) {
        window.requestAnimationFrame(scrollToTarget);
      }
    };

    window.requestAnimationFrame(scrollToTarget);
    window.addEventListener(
      'load',
      () => {
        window.scrollTo({ top: targetY, behavior: 'auto' });
        revealPage();
      },
      { once: true }
    );
  };

  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }

  document.addEventListener('click', (event) => {
    const root = event.target.closest('[data-blog-scroll-restore]');
    const link = event.target.closest('a[href]');

    if (!root || !link || !root.contains(link) || event.defaultPrevented || isModifiedClick(event)) {
      return;
    }

    if (link.target && link.target !== '_self') {
      return;
    }

    if (!isArticleLink(link)) {
      return;
    }

    setStoredState({
      page: getPageKey(),
      scrollY: window.scrollY,
      savedAt: Date.now(),
    });
  });

  window.addEventListener('pageshow', restoreScrollPosition);
})();
